// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"738":"ef4c45e4","2860":"597dd656","3350":"2c613d95","4150":"7c7a0829","7845":"840d02f6","7979":"10503989"}[chunkId] + ".chunk.css";
};